import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceWidget = ({ title, value, total, icon, iconBg, trend, trendValue }) => {
  const percentage = total > 0 ? Math.round((value / total) * 100) : 0;

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-elevation-2 border border-border transition-smooth hover:shadow-elevation-3">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <div className="flex items-baseline gap-2">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground data-text">
              {value}
            </h3>
            <span className="text-sm md:text-base text-muted-foreground">/ {total}</span>
          </div>
        </div>
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${iconBg}`}>
          <Icon name={icon} size={20} color="white" />
        </div>
      </div>

      <div className="space-y-2">
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-500"
            style={{ width: `${percentage}%` }}
            role="progressbar"
            aria-valuenow={percentage}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>

        <div className="flex items-center justify-between">
          <span className="text-xs md:text-sm text-muted-foreground">{percentage}% Complete</span>
          {trend && (
            <div className={`flex items-center gap-1 text-xs md:text-sm ${trend === 'up' ? 'text-success' : 'text-error'}`}>
              <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
              <span className="data-text">{trendValue}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PerformanceWidget;